import { useMemo, useReducer } from 'react';
import { LanguageProvider as LanguageProviderBase, useLanguage } from 'react-admin-base-bootstrap';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const defaultLanguage = require('./en.json');
function messages(lang) { return {...defaultLanguage, ...lang}; };

export const languageList = [
	{
		code: 'en',
		name: 'English',
		flag: require('svg-country-flags/svg/us.svg'),
		messages: defaultLanguage
	},
	{
		code: 'pl',
		name: 'Polish',
		flag: require('svg-country-flags/svg/pl.svg'),
		messages: messages(require('./pl.json'))
	},
	{
		code: 'no',
		name: 'Norwegian',
		flag: require('svg-country-flags/svg/no.svg'),
		messages: messages(require('./no.json'))
	},
	{
		code: 'es',
		name: 'Spanish',
		flag: require('svg-country-flags/svg/es.svg'),
		messages: messages(require('./es.json'))
	}
];

const languages = languageList.reduce((a, b) => (a[b.code] = b) && a, {});

export default function LanguageProvider(props) {
	const messages = useMemo(() => (Object.values(languageList).reduce((a,b) => ({ ...a, [b.code]: b}), {})), [ languageList ]);
	
	return <LanguageProviderBase defaultLanguage="en" languages={messages} {...props} />;
}

export function LanguageSwitcherBasic({ className }) {
	const [ activeLanguage,, setLang ] = useLanguage();
	const [ isOpen, toggleMenu ] = useReducer((a) => !a, false);
	
	const realLang = activeLanguage;
	const changeLang = (lang, e) => {
		e.preventDefault();
		setLang(lang.code);
	};

	return <div className={className}>
		<Dropdown isOpen={isOpen} toggle={toggleMenu} id="languagemenu">
			<DropdownToggle tag="button" className="btn header-item waves-effect" caret>
				{ realLang.flag && <img className="me-2" src={realLang.flag.default} alt="Header Language" height="16"/> } { realLang.name } <span className="mdi mdi-chevron-down" />
			</DropdownToggle>
			<DropdownMenu>
				{ languageList
					.map(a => <DropdownItem tag="a" href="#" className="notify-item" onClick={changeLang.bind(this, a)}>
					 	{ a.flag && <img className="me-2" src={a.flag.default} alt={a.name} height="8"/> } <span className="align-middle">{ a.name }</span>
					</DropdownItem>) }
			</DropdownMenu>
		</Dropdown>
	</div>;
}
